import { render, staticRenderFns } from "./AlignerScreenShotDialog.vue?vue&type=template&id=8d35d1da"
import script from "./AlignerScreenShotDialog.vue?vue&type=script&lang=js"
export * from "./AlignerScreenShotDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports